import React from "react";
import { Route, Navigate, Outlet } from "react-router-dom";

import { isAuthenticated } from "./security";
import { useUser } from "../pages/authentification/UserContext";

const PrivateRoute = ({ allowedRoles, requiresFormCompleted }) => {
  const { user } = useUser();
  const { role } = user;
  console.log("Role", role);

  console.log("🔎 Checking PrivateRoute: ", { user });

  // Case 1: If user is null (not authenticated), redirect to login
  if (!user || !user.token) {
    console.log("🔄 Redirecting to /login because user is null or no token");
    return <Navigate to="/login" replace />;
  }

  // Case 2: If form completion is required but user has not completed it
  if (
    requiresFormCompleted &&
    user.role === "ROLE_USER" &&
    !user.hasCompletedForm
  ) {
    console.log(
      "🔄 Redirecting to /debutformulaire because form is incomplete"
    );
    return <Navigate to="/debutformulaire" replace />;
  }

  // Case 4: If user does not have required roles
  if (!allowedRoles.includes(user.role)) {
    console.log("🚫 Unauthorized: Redirecting to /unauthorized");
    return <Navigate to="/unauthorized" replace />;
  }

  //   return <Route {...rest} render={(props) => <Component {...props} />} />;
  return <Outlet />;
};
export default PrivateRoute;
